<template>
  <van-dialog id="van-dialog" title="提示" show-cancel-button v-model="isShowTip" v-if="type == 3">
    <div class="wrapper">
      <div class="form-group no-result-tip">
        查无该笔交易记录，请联系客服
      </div>
    </div>
  </van-dialog>
  <van-dialog id="van-dialog" title="提示" show-cancel-button v-model="isShowTip" v-else-if="type == 4">
    <div class="wrapper">
      <div class="form-group no-result-tip">
        {{orderInfo.errorDesc}}
      </div>
    </div>
  </van-dialog>
  <van-dialog id="van-dialog" title="充值成功" show-cancel-button v-model="isShowTip" v-else-if="type != 4 || type != 3">
    <div class="wrapper">
      <div class="form-group">
        <div class="label-wrap">支付宝交易号</div>
        <div class="form-item-wrap">{{orderInfo.tradeNo}}</div>
      </div>
      <div class="form-group">
        <div class="label-wrap">充值时间</div>
        <div class="form-item-wrap">{{orderInfo.createTime}}</div>
      </div>
      <div class="form-group">
        <div class="label-wrap">交易金额</div>
        <div class="form-item-wrap money-color">{{orderInfo.amount}}</div>
      </div>
    </div>
  </van-dialog>
</template>
<script>
export default {
  name: 'AccountTip',
  data: function () {
    return {
      type: 1, // 1-充值成功 2-重复充值 3-未查询交易记录
      orderInfo: {
        title: '',
        tradeNo: '',
        createTime: '',
        amount: 0,
        errorDesc: ''
      },
      isShowTip: false
    }
  },
  methods: {
    init: function (type, orderInfo) {
      this.type = type
      this.orderInfo = orderInfo
      this.isShowTip = true
    },
    handelCancel: function () {
      this.isShowTip = false
    },
    handelSubmit: function () {
      this.isShowTip = false
    }
  }
}
</script>
<style lang="less" scoped>
  .van-dialog{
    .form-group {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      min-width: 0;
      padding: 0 20px;
      margin-bottom: 10px;
      .label-wrap {
        font-size: 14px;
        color: #666;
        letter-spacing: 0;
        width: 1.68rem;
        text-align: right;
        margin-right: 0.32rem;
      }
    }
    .no-result-tip {
      font-size: 14px;
      color: #222222;
      justify-content: center;
      margin-top: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/account/modal/Tip.vue